import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchSampleLog, type SampleLogSnapshot } from "../lib/sampleLogApi";

const POLL_MS = 1000;

export function useSampleLog() {
  const location = useLocation();
  const enabled = location.pathname === "/fcr";
  const [snapshot, setSnapshot] = useState<SampleLogSnapshot | null>(null);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    try {
      const data = await fetchSampleLog();
      setSnapshot(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    void reload();
    const id = window.setInterval(() => void reload(), POLL_MS);
    return () => window.clearInterval(id);
  }, [enabled, location.key, reload]);

  return { snapshot, error, reload };
}
